import React from "react";
import { Route, Routes } from "react-router-dom";
import { ConversationList } from "./pages";
import Marketing from "./Section/Marketing/Marketing";
import EventName from "./Section/EventName/EventName";
import {useUserCheckPermissions} from "../../../hooks/useUserCheckPermissions";
import {PermissionCodes} from "../../../utils/enums";

export const ConversationPage = () => {
    const {checkPermission} = useUserCheckPermissions();
  return (
    <Routes>
      <Route path="/trigger" element={<EventName />} />
      {(checkPermission(PermissionCodes.MARKETING, "CREATE") ||
        checkPermission(PermissionCodes.MARKETING, "VIEW")) && (
          <>
              <Route index element={<ConversationList />} />
              <Route path="/marketing" element={<Marketing />} />
          </>
      )}
    </Routes>
  );
};

export default ConversationPage;
